<template>
  <div>
    <div class="py-4 container-fluid">
      <div class="row">
        <div class="col-12">
          <div class="card" style="height: 655px;">
            <!-- Card header -->
            <div class="card-header py-3">
              <div class="d-lg-flex align-items-center row py-1">
                <div class="col-6">
                  <h5 class="mb-0">My Task</h5>
                </div>
                <div class="col-6">
                  <div class="my-auto ms-auto float-end">
                    <button type="button" class="mx-1 mb-0 btn bg-gradient-info btn-sm" data-bs-toggle="modal"
                      data-bs-target="#modalMyTaskHistory" @click="fetchHistory">
                      My Task History
                    </button>
                    <button type="button" class="mx-1 mb-0 btn bg-gradient-dark btn-sm" data-bs-toggle="modal"
                      data-bs-target="#modalFilterMyTask">
                      filter
                    </button>
                  </div>
                </div>
              </div>
            </div>
            <!-- Card Body -->
            <div style="height: 500px; overflow-y: auto;">
              <DataTable :value="myTask.onLoad ? dummyRows : myTask.data" removable-sort scrollable scroll-height="flex"
                table-style="min-width: 50rem" class="text-sm"
                :row-class="() => myTask.onLoad ? 'task-row-loading' : 'task-row'"
                @row-click="!myTask.onLoad && openTask($event.data)">
                <Column field="data.mcr_number" header="MCR Number" header-class="bg-light text-dark" sortable>
                  <template v-if="myTask.onLoad" #body>
                    <Skeleton></Skeleton>
                  </template>
                  <template v-else #body="slotProps">
                    {{ slotProps.data && slotProps.data.data ? (slotProps.data.data.mcr_number || '-') : '-' }}
                  </template>
                </Column>
                <Column field="data.subject" header="Subject" header-class="bg-light text-dark" sortable>
                  <template v-if="myTask.onLoad" #body>
                    <Skeleton></Skeleton>
                  </template>
                  <template v-else #body="slotProps">
                    {{ slotProps.data && slotProps.data.data ? slotProps.data.data.subject : '' }}
                  </template>
                </Column>
                <Column field="data.type" header="Type" header-class="bg-light text-dark" sortable>
                  <template v-if="myTask.onLoad" #body>
                    <Skeleton></Skeleton>
                  </template>
                  <template v-else #body="slotProps">
                    {{ formatType(slotProps.data && slotProps.data.data ? slotProps.data.data.type : '') }}
                  </template>
                </Column>
                <Column field="data.user_created.name" header="Creator" header-class="bg-light text-dark" sortable>
                  <template v-if="myTask.onLoad" #body>
                    <Skeleton></Skeleton>
                  </template>
                  <template v-else #body="slotProps">
                    {{ slotProps.data && slotProps.data.data && slotProps.data.data.user_created ?
                      slotProps.data.data.user_created.name : '' }}
                  </template>
                </Column>
                <Column v-if="isInalum" field="data.department" header="Department" header-class="bg-light text-dark" sortable>
                  <template v-if="myTask.onLoad" #body>
                    <Skeleton></Skeleton>
                  </template>
                  <template v-else #body="slotProps">
                    {{ slotProps.data && slotProps.data.data ? (slotProps.data.data.department || '-') : '-' }}
                  </template>
                </Column>
                <Column field="data.status" header="Status" header-class="bg-light text-dark" sortable>
                  <template v-if="myTask.onLoad" #body>
                    <Skeleton></Skeleton>
                  </template>
                  <template v-else #body="slotProps">
                    <span class="badge"
                      :class="statusBadgeClass(slotProps.data && slotProps.data.data ? slotProps.data.data.status : '')">
                      {{ slotProps.data && slotProps.data.data ? slotProps.data.data.status : '' }}
                    </span>
                  </template>
                </Column>
                <Column field="data.created_at" header="Created At" header-class="bg-light text-dark" sortable>
                  <template v-if="myTask.onLoad" #body>
                    <Skeleton></Skeleton>
                  </template>
                  <template v-else #body="slotProps">
                    {{ slotProps.data && slotProps.data.data && slotProps.data.data.created_at ?
                      formatDate(slotProps.data.data.created_at) : '' }}
                  </template>
                </Column>
                <template #empty>
                  <div style="text-align: center; padding: 40px 0;">
                    <img src="/no_data.png" alt="No Data" style="max-width: 330px; opacity: 0.7; margin-bottom: 0;" />
                    <div style="color: #888; font-size: 1.1em; font-weight: 500;">No Data</div>
                  </div>
                </template>
              </DataTable>
            </div>
            <div class="card-footer pb-0">
              <span class="float-start">
                <BasePagination v-model="myTask.page.current_pages" :page-count="myTask.page.total_pages" size="sm"
                  @click="changePage()" />
              </span>
              <span class="float-end">
                {{ ((myTask.page.current_pages - 1) * myTask.page.per_pages) + myTask.data.length }} of {{ myTask.total
                }}
              </span>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- Modal Filter -->
    <div id="modalFilterMyTask" class="modal fade" tabindex="-1" aria-hidden="true">
      <div class="modal-dialog modal-dialog-centered">
        <div class="modal-content">
          <div class="modal-header">
            <h5 id="ModalFilterMyTask" class="modal-title">
              Filter
            </h5>
            <a class="text-dark btn-close pt-1" style="font-size: 20px;" aria-hidden="true" data-bs-dismiss="modal"
              href="#">
              <span aria-hidden="true"><b>&times;</b></span>
            </a>
          </div>
          <div class="modal-body">
            <div class="row">
              <div class="col-12">
                <label class="form-label">Description</label>
                <input v-model="modalFilterMyTaskList.data.description" class="form-control" type="text"
                  placeholder="Write the Created by" />
              </div>
              <div class="col-12">
                <label class="form-label">MCR Code</label>
                <input v-model="modalFilterMyTaskList.data.order_number" class="form-control" type="text"
                  placeholder="Write the Order Code" />
              </div>
            </div>
          </div>
          <div class="modal-footer">
            <button ref="closeModalFilterMyTask" type="button" class="btn bg-gradient-danger btn-sm"
              data-bs-dismiss="modal">
              Close
            </button>
            <button type="button" class="btn bg-gradient-primary btn-sm" :disabled="modalFilterMyTaskList.onLoad"
              @click="filterMyTask">
              <span v-if="modalFilterMyTaskList.onLoad"><i class="fas fa-spinner fa-spin"></i>&nbsp;&nbsp;&nbsp;Please
                wait</span>
              <span v-else>Filter</span>
            </button>
          </div>
        </div>
      </div>
    </div>

    <!-- Modal My Task History -->
    <div id="modalMyTaskHistory" class="modal fade" tabindex="-1" aria-hidden="true">
      <div class="modal-dialog modal-dialog-centered modal-lg">
        <div class="modal-content">
          <div class="modal-header">
            <h5 class="modal-title">My Task History</h5>
            <a class="text-dark btn-close pt-1" style="font-size: 20px;" aria-hidden="true" data-bs-dismiss="modal"
              href="#">
              <span aria-hidden="true"><b>&times;</b></span>
            </a>
          </div>
          <div class="modal-body p-0">
            <div v-if="myTaskHistory.onLoad" class="text-center py-4">
              <i class="fas fa-spinner fa-spin"></i> Loading...
            </div>
            <div v-else class="table-responsive" style="min-height: 350px; max-height: 500px; overflow-y: auto;">
              <table v-if="myTaskHistory.data.length > 0" class="table">
                <thead class="table-primary text-center" style="position: sticky; top: 0; z-index: 1;">
                  <tr class="align-middle">
                    <th class="text-uppercase text-start text-dark text-xxs font-weight-bolder">MCR Number</th>
                    <th class="text-uppercase text-start text-dark text-xxs font-weight-bolder">Subject</th>
                    <th class="text-uppercase text-start text-dark text-xxs font-weight-bolder">Creator</th>
                    <th class="text-uppercase text-start text-dark text-xxs font-weight-bolder">Status</th>
                    <th class="text-uppercase text-start text-dark text-xxs font-weight-bolder">Executed At</th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-for="mTask in myTaskHistory.data" :key="mTask.data.id" class="align-middle">
                    <td class="text-sm py-3 px-4">{{ mTask.data.mcr_number || '-' }}</td>
                    <td class="text-sm py-3 px-4">{{ mTask.data.subject }}</td>
                    <td class="text-sm py-3 px-4">{{ mTask.data.user_created.name }}</td>
                    <td class="text-sm py-3 px-4">
                      <span class="badge" :class="statusBadgeClass(mTask.data.status)">{{ mTask.data.status }}</span>
                    </td>
                    <td class="text-sm py-3 px-4">{{ formatDate(mTask.executed_at) }}</td>
                  </tr>
                </tbody>
              </table>
              <div v-else class="text-center py-4 text-muted">No history data found.</div>
            </div>
          </div>
          <div class="modal-footer" style="border-top: none; padding: 0.4rem 1rem;">
            <button type="button" class="btn bg-gradient-danger btn-sm" data-bs-dismiss="modal">Close</button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import BasePagination from "@/components/BasePagination.vue";
import moment from "moment";

import api from '@/helpers/api';
import myTaskService from '@/services/dashboards/myTaskService';
import formConfigService from '@/services/materialCatalogingRequest/formConfigService';

const getCompanyCode = () => {
  try { return JSON.parse(localStorage.getItem('userAuth') || '{}')?.user?.company_code || ''; } catch { return ''; }
};
const ANTAM_EXCLUDED_MCR_TYPES = ['MCR006', 'MCR008', 'MCR009'];

export default {
  components: {
    BasePagination,
  },
  data() {
    return {
      loadTimeout: null,
      dummyRows: Array.from({ length: 10 }, () => ({})),
      typeOptions: [],
      myTask: {
        total: 0,
        data: [],
        page: {
          current_pages: 1,
        },
        onLoad: true
      },
      modalFilterMyTaskList: {
        data: {
          description: this.$route.query.description ?? '',
          order_number: this.$route.query.order_number ?? '',
          type: "open",
        },
        onLoad: false
      },
      myTaskHistory: {
        data: [],
        onLoad: false
      },
      errorMessage: [],
    }
  },
  computed: {
    isInalum() {
      return getCompanyCode() === 'INALUM';
    }
  },
  mounted() {
    this.fetchTypeOptions();
    this.get()
  },
  methods: {
    async fetchTypeOptions() {
      try {
        const response = await api(this, formConfigService.get('mcr_type'), false);
        let types = response?.data?.data || [];
        if (getCompanyCode() === 'ANTAM') {
          types = types.filter(t => !ANTAM_EXCLUDED_MCR_TYPES.includes(t.code));
        }
        this.typeOptions = types.map(t => ({
          label: `${t.code} - ${t.description}`,
          value: t.code
        }));
      } catch (error) {
        console.error("Failed to fetch MCR types:", error);
      }
    },
    formatType(type) {
      if (!type) return "";
      const option = this.typeOptions.find(opt => opt.value === type);
      if (option) return option.label;

      const map = { 'mrp': 'UPDATE MRP', 'create-new': 'CREATE-NEW', 'flag-unflag': 'FLAG-UNFLAG', 'change-material': 'CHANGE-MATERIAL', 'block-unblock': 'BLOCK-UNBLOCK', 'extend': 'EXTEND', 'update-price': 'UPDATE-PRICE', 'mass-update-mrp': 'MASS UPDATE MRP', 'mcr007': 'MASS UPDATE MRP' };
      return map[type] || map[String(type).toLowerCase()] || type;
    },
    async get() {
      try {
        const response = await api(this, myTaskService.list(this.modalFilterMyTaskList.data.type, this.myTask.page.current_pages, this.modalFilterMyTaskList.data), false)
        this.myTask.data = response.data.data
        this.myTask.total = response.data.total;
        this.myTask.page = response.data;

      } catch (error) {
        if (error.response?.data?.code == 400) {
          error.response.data.data.forEach((v) => {
            this.modal.errorMessage[v.path] = v.msg
          })
        }
      } finally {
        this.myTask.onLoad = false
      }
    },
    filterMyTask() {
      this.myTask.onLoad = true
      this.modalFilterMyTaskList.onLoad = true
      this.myTask.page.current_pages = 1

      clearTimeout(this.loadTimeout);
      this.loadTimeout = setTimeout(() => {
        this.$router.push({
          query: {
            description: this.modalFilterMyTaskList.data.description ?? '',
            order_number: this.modalFilterMyTaskList.data.order_number ?? '',
            // order_type: this.modalFilterMyTaskList.data.order_type ?? 'draft'
          }
        })

        this.$refs.closeModalFilterMyTask.click()
        this.modalFilterMyTaskList.onLoad = false
        this.get()

      }, 500);
    },
    changePage() {
      clearTimeout(this.loadTimeout);
      this.loadTimeout = setTimeout(() => {
        this.get()
      }, 100);
    },
    async fetchHistory() {
      this.myTaskHistory.onLoad = true;
      try {
        const response = await api(this, myTaskService.list('closed', 1, {}), false);
        this.myTaskHistory.data = response.data.data;
      } catch {
        this.myTaskHistory.data = [];
      } finally {
        this.myTaskHistory.onLoad = false;
      }
    },
    openTask(mTask) {
      // const route = this.$router.resolve({
      //   name: 'MCR Form for My Task MCR',
      //   params: { id: mTask.data.id, action: 'edit', mcrCode: mTask.data.mcr_code }
      // });
      // window.open(route.href, '_blank');
      this.$router.push({
        name: 'MCR Form for My Task MCR',
        params: { moduleSlug: 'material-management', id: mTask.data.id, action: 'edit', mcrCode: mTask.data.mcr_code }
      });
    },
    statusBadgeClass(status) {
      const s = (status || '').toLowerCase();
      if (s === 'closed' || s === 'rejected') return 'bg-danger';
      if (s === 'draft') return 'bg-secondary';
      if (s === 'processed') return 'bg-primary';
      if (s === 'catalogued' || s === 'sap') return 'bg-success';
      return 'bg-secondary';
    },
    formatDate(dateString) {
      return moment(dateString).format("DD/MM/YYYY HH:mm");
    },
  }
};
</script>
<style>
.task-row {
  cursor: pointer;
}

.task-row:hover {
  background-color: #fffde7;
}

.task-row-loading {
  cursor: default;
}
</style>
